export default "__VITE_ASSET__BlN0SY2r__"